<template>
  <div class="position-relative">
    <custom-callout
      class="mt-4"
      :border-color="'secondary-5'"
      :status-color="'blue'"
      :has-toggle="canShowMoreInformation"
      :controlled="true"
      ref="callout"
      :opened="showMoreInformation"
      @click:open="toggleCallout()"
    >
      <div class="row px-lg- py-md-3 ml-n4 mr-1">
        <div class="col-12 col-lg-3">
          <label for="" class="text-muted font-weight-normal font-14">
            Nombre del Dashboard:
          </label>
          <p class="font-weight-bold font-16">
            {{ item.name | empty }}
          </p>
        </div>
        <div class="col-12 col-lg-2">
          <label for="" class="text-muted font-weight-normal font-14">
            Estatus de última actualización:
          </label>
          <p v-if="detail.statusName" class="font-weight-bold font-16">
            <i class="fas fa-circle font-12 mr-2" :class="statusColor"></i>
            {{ detail.statusName | empty }}
          </p>
          <p v-else class="font-weight-normal">-</p>
        </div>
        <div class="col-12 col-lg-2">
          <label for="" class="text-muted font-weight-normal font-14">
            Fecha de última actualización:
          </label>
          <p class="font-weight-normal font-16">
            {{ detail.updatedDate | datetime }}
          </p>
        </div>
        <div class="col-12 col-lg-3">
          <label for="" class="text-muted font-weight-normal font-14">
            Usuario de última actualización:
          </label>
          <p class="font-weight-normal font-16">
            {{ detail.updatedUserName | empty }}
          </p>
        </div>
        <div
          v-if="!item.existSomeProcessRunning"
          class="col-12 col-lg-2 d-flex justify-content-lg-end"
        >
          <action-button
            class="button-size"
            id="modal-btn-cancelar"
            variant="outline-success btn-green"
            type="button"
            i="fas fa-sync-alt"
            @click="$emit('update', item)"
          >
            Actualizar
          </action-button>
        </div>
      </div>
    </custom-callout>
    <more-information
      v-if="showMoreInformation"
      :message-error="detail.errorMessage"
      @close="toggleCallout()"
    />
    <div v-else>
      <callout-alert
        v-if="isProcessing"
        message="Actualizando Dashboard..."
        icon-class="fad fa-spinner fa-spin"
        variant="warning"
      />
      <callout-alert
        v-if="!isProcessing && hasError"
        message="Se produjo un error al ejecutar el proceso. Por favor, inténtalo de nuevo más tarde o ponte en contacto con el administrador del sistema para obtener asistencia."
        icon-class="fas fa-times-circle"
        variant="danger"
      />
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout'
import ActionButton from 'ActionButton'
import MoreInformation from './MoreInformation'
import { CalloutAlert } from '@/components/common'
import loadControlStatus from '@/utils/constants/loadControlStatus.js'

export default {
  name: 'ResultRow',
  components: {
    CustomCallout,
    ActionButton,
    CalloutAlert,
    MoreInformation,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showMoreInformation: false,
    }
  },
  computed: {
    detail() {
      return this.item?.detail || {}
    },
    statusColor() {
      return this.hasError ? 'text-danger' : 'text-green-light'
    },
    statusMessage() {
      return 'Actualizando Dashboard...'
    },
    hasError() {
      return (
        this.item.detail &&
        this.item.detail?.statusId == loadControlStatus.Error
      )
    },
    canShowMoreInformation() {
      return this.userHasPermissions(
        'menu.report.dashboard.view.sourceupdate.aditionalinfosystem'
      )
    },
    isProcessing() {
      return this.item.inProcess
    },
  },
  methods: {
    toggleCallout() {
      this.showMoreInformation = !this.showMoreInformation
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';

.text-green-light {
  color: map-get($colors, 'green-light');
}
.alert-pending {
  background-color: #feeeb7;

  & p,
  i {
    color: #af6717;
  }
}
</style>
